import * as yup from 'yup'

export const schema = yup.object().shape({
  pageName: yup.string().required(),
  pageUri: yup.string().required(),
  status: yup.string().required(),
})

export default schema
